import { useEffect, useState } from "react";
import * as messengerService from "V2.0/services/messengerService";

function useMessengerConfiguration(projectId) {
  const [messengerConfiguration, setMessengerConfiguration] = useState({
    data: null,
    loading: true,
    isConfigured: false,
  });

  const fetchMessengerConfiguration = async (projectId) => {
    setMessengerConfiguration((prevState) => ({ ...prevState, loading: true }));
    try {
      const response = await messengerService.getMessengerConfig(projectId);
      const data = response.data;
      setMessengerConfiguration({ data, loading: false, isConfigured: true });
    } catch (error) {
      const response = error.response;
      if (response.status === 404) {
        setMessengerConfiguration((prevState) => ({
          ...prevState,
          loading: false,
          isConfigured: false,
        }));
      }
      console.error(error);
    }
  };

  useEffect(() => {
    if (projectId) {
      fetchMessengerConfiguration(projectId);
    }
  }, [projectId]);

  return {
    messengerConfiguration,
    fetchMessengerConfiguration,
  };
}

export { useMessengerConfiguration };
